import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { eTypeResult } from 'src/app/models/common/enumModel';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { ICompaniaModel } from 'src/app/models/interfaces/compania/ICompaniaModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { CompaniaService } from 'src/app/services/compania/compania.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-configuracion-compania-registrar',
  templateUrl: './configuracion-compania-registrar.component.html',
  styleUrls: ['./configuracion-compania-registrar.component.css']
})
export class ConfiguracionCompaniaRegistrarComponent implements OnInit {
  model: ICompaniaModel = new CompaniaModel();
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private companiaService: CompaniaService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
    ) { }

  ngOnInit(): void {
    
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {   
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.companiaService.submit(this.model).subscribe((result: ActionResultModel) => {
            if(result.type!=eTypeResult.SUCCESS){
              this.alertDialogService.open(result.message);
            }
            else{
            this.alertDialogService.open("La compañía fue registrada");
            this.router.navigate(['/configuracion', 'companias']);  
            }
          });
        }
      });
    }
  }

}
